import React, {useState} from 'react';
import {Link, useLocation} from 'react-router-dom';
import CGG_LOGO from '../../assets/images/common/common_cgg_logo.png';

const Header = () => {
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);
  const [isMenuVisible, setIsMenuVisible] = useState(false);

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  
  // 섹션으로 스크롤 이동하는 함수
  const scrollToSection = (sectionId: string) => {
    const section = document.getElementById(sectionId);
    if (section) {
      // 헤더 높이를 고려하여 스크롤 위치 조정 (헤더 높이는 80px)
      const offsetTop = section.offsetTop - 40;
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      });
    }
  };

  const openMobileMenu = () => {
    setIsMenuVisible(true);
    setTimeout(() => {
      setIsMobileMenuOpen(true);
    }, 10); // 약간의 딜레이로 트랜지션 트리거
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
    setIsAnimating(true);
    setTimeout(() => {
      setIsMenuVisible(false);
      setIsAnimating(false);
    }, 300); // 애니메이션 시간과 맞춤
  };

  return (
    <>
      <header className="fixed top-0 left-0 right-0 z-50 bg-white shadow-md  h-[40px] md:h-[60px] lg:h-[80px]">
        <div className="container h-full">
          <div className="flex items-center justify-between h-full">
            <div className="flex items-center">
              <Link to="/" className="flex items-center" onClick={scrollToTop}>
                <img
                  src={CGG_LOGO}
                  alt="CGG"
                  className=" h-[18px] md:h-[26px] lg:h-[34px] w-auto"
                />
              </Link>
            </div>
            <div className="hidden lg:flex items-center space-x-[26px]">
              <nav className="hidden lg:flex items-center space-x-[60px]">
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection('about');
                  }}
                  className="text-xl font-normal transition-colors duration-200 text-black hover:text-[#7A2FC0]"
                >
                  About
                </a>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection('business');
                  }}
                  className="text-xl font-normal transition-colors duration-200 text-black hover:text-[#7A2FC0]"
                >
                  Business
                </a>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection('howwework');
                  }}
                  className="text-xl font-normal transition-colors duration-200 text-black hover:text-[#7A2FC0]"
                >
                  How we work
                </a>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection('contact');
                  }}
                  className="text-xl font-normal transition-colors duration-200 text-black hover:text-[#7A2FC0]"
                >
                  Contact
                </a>
              </nav>
            </div>
            {/* Mobile Menu Button */}
            <button
              className="lg:hidden"
              onClick={openMobileMenu}
              aria-label="Toggle mobile menu"
            >
              <svg
                className="w-10 h-10"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Menu Overlay */}
      {(isMenuVisible || isAnimating) && (
        <>
          {/* Dimmed background - 전체 화면 */}
          <div
            className="fixed inset-0 bg-black bg-opacity-50 z-40"
            onClick={closeMobileMenu}
          />
          {/* Side panel - 오른쪽에 붙도록 right-0 */}
          <div
            className={`fixed top-0 right-0 h-full w-[80vw] max-w-xs bg-white shadow-lg z-50
              transition-transform duration-300
              ${isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'}`}
          >
            <div className="px-4 py-6 h-full flex flex-col justify-between">
              <div>
                {/* Close Button */}
                <button
                  className="absolute top-6 right-4 p-2"
                  onClick={closeMobileMenu}
                  aria-label="Close mobile menu"
                >
                  <svg
                    className="w-7 h-7"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
                {/* Mobile Navigation */}
                <nav className="flex flex-col space-y-1 mt-16">
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToSection('about');
                      closeMobileMenu();
                    }}
                    className="font-pretendard font-normal text-[20px] text-black hover:text-[#7A2FC0] py-2 px-2"
                  >
                    About
                  </a>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToSection('business');
                      closeMobileMenu();
                    }}
                    className="font-pretendard font-normal text-[20px] text-black hover:text-[#7A2FC0] py-2 px-2"
                  >
                    Business
                  </a>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToSection('howwework');
                      closeMobileMenu();
                    }}
                    className="font-pretendard font-normal text-[20px] text-black hover:text-[#7A2FC0] py-2 px-2"
                  >
                    How we work
                  </a>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToSection('contact');
                      closeMobileMenu();
                    }}
                    className="font-pretendard font-normal text-[20px] text-black hover:text-[#7A2FC0] py-2 px-2"
                  >
                    Contact
                  </a>
                </nav>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Header;